import { chain } from '@leprecoins/effector';
import { createForm } from '@leprecoins/effector-forms';
import { createStore, sample } from 'effector';
import { delay, spread } from 'patronum';
import { getBetHistoryQuery } from 'shared/api';
import { createModalSwitcher } from 'shared/lib';
import { groupBetsByDate, HistoryBetsByDate } from '../lib';

const myBetsSwitcher = createModalSwitcher();

const $bets = createStore<HistoryBetsByDate[] | null>(null);

const $totalPages = createStore(0);

const paginationForm = createForm({
	fields: {
		page: {
			init: 1,
		},
		limit: {
			init: 20,
		},
	},
});

const pageField = paginationForm.fields.page;

sample({
	clock: [myBetsSwitcher.enabled, pageField.$value],
	source: paginationForm.$values,
	filter: myBetsSwitcher.$active,
	target: getBetHistoryQuery.start,
});

sample({
	clock: getBetHistoryQuery.finished.success,
	source: paginationForm.fields.limit.$value,
	fn: (limit, { result }) => ({
		totalPages: Math.ceil(result.count / limit),
		bets: groupBetsByDate(result.rows),
	}),
	target: spread({
		bets: $bets,
		totalPages: $totalPages,
	}),
});

chain(delay(myBetsSwitcher.disabled, 200), paginationForm.reset);

export const myBetsModalModel = {
	myBetsSwitcher,
	pageField,
	$bets,
	$totalPages,
};
